import React, { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'src/shared/components/tooltip'
import { twMerge } from 'tailwind-merge'

export interface OptionWrapperProps {
  labelText?: string
  required?: boolean
  resetText?: string
  directionRow?: boolean
  isResetIconVisible?: boolean
  labelIcon?: ReactNode
  helpMessage?: string
  skipTranslation?: boolean
  itemStyles?: React.CSSProperties
  width?: number
  fullWidth?: boolean
  onReset?: () => void
  labelClassName?: string
  className?: string
}

export const OptionWrapper = ({
  labelClassName,
  labelText,
  required,
  labelIcon,
  isResetIconVisible = false,
  resetText = '',
  directionRow = false,
  children,
  helpMessage = '',
  skipTranslation,
  itemStyles = {},
  width,
  onReset,
  className,
}: PropsWithChildren<OptionWrapperProps>) => {
  const { t } = useTranslation()

  return (
    <div
      style={itemStyles}
      className={twMerge(
        'relative mt-3.5 flex flex-col items-start justify-start last-of-type:mb-5',
        width && `[&>div]:width-[${width}]`,
        directionRow && 'flex-row items-center justify-between',
        itemStyles.marginBottom &&
          `last-of-type:mb-[${itemStyles.marginBottom}]`,
        className,
      )}
    >
      {labelText && (
        <div
          className={twMerge(
            'mb-2 block basis-full text-M text-textTertiary',
            directionRow && 'mb-0 basis-[165px]',
            labelClassName,
          )}
        >
          {labelText && helpMessage ? (
            <Tooltip message={skipTranslation ? helpMessage : t(helpMessage)}>
              {skipTranslation ? labelText : t(labelText)}
            </Tooltip>
          ) : skipTranslation ? (
            labelText
          ) : (
            t(labelText)
          )}
          {required && <span className="ml-0.5 text-error-500">*</span>}
          {labelIcon}
          {isResetIconVisible && (
            <button type="button" onClick={onReset} title={t(resetText)}>
              <i className="fa fa-ban ml-2.5 cursor-pointer" />
            </button>
          )}
        </div>
      )}

      <div className={twMerge(!directionRow && 'float-right h-auto w-full')}>
        {children}
      </div>
    </div>
  )
}
